module.exports = "/_next/static/images/82cd074b42a0565374f206cb4e273d94-nubanker-bizarch@0.75x.jpg.webp";